/* ==========================================================================
   hc-shop-the-look — Mobile Scroll Indicators
   ========================================================================== */

(function() {
  'use strict';

  var MOBILE_BREAKPOINT = 749;

  /**
   * Initialize scroll indicators for a single section instance.
   * @param {HTMLElement} section - The .hc-shop-the-look element.
   */
  function initShopTheLook(section) {
    var grid = section.querySelector('[data-js="look-grid"]');
    var indicatorsContainer = section.querySelector('[data-js="look-indicators"]');

    if (!grid || !indicatorsContainer) return;

    var cards = grid.querySelectorAll('[data-js="look-card"]');
    var cardCount = cards.length;

    if (cardCount === 0) return;

    // --- Build indicator dots ---
    indicatorsContainer.innerHTML = '';
    for (var i = 0; i < cardCount; i++) {
      var dot = document.createElement('span');
      dot.className = 'hc-shop-the-look__indicator';
      if (i === 0) dot.classList.add('is-active');
      indicatorsContainer.appendChild(dot);
    }

    var dots = indicatorsContainer.querySelectorAll('.hc-shop-the-look__indicator');

    // --- Track scroll position ---
    function updateIndicators() {
      if (window.innerWidth > MOBILE_BREAKPOINT) return;

      var scrollLeft = grid.scrollLeft;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(grid).gap) || 20;
      var step = cardWidth + gap;
      var activeIndex = Math.round(scrollLeft / step);

      activeIndex = Math.max(0, Math.min(activeIndex, cardCount - 1));

      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === activeIndex);
      }
    }

    var scrollTimeout;
    grid.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateIndicators, 50);
    }, { passive: true });

    window.addEventListener('resize', updateIndicators);
  }

  // --- Init all instances on page load ---
  var sections = document.querySelectorAll('.hc-shop-the-look');
  for (var i = 0; i < sections.length; i++) {
    initShopTheLook(sections[i]);
  }

  // --- Re-init on Theme Editor section load ---
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.hc-shop-the-look');
    if (section) initShopTheLook(section);
  });
})();
